<template>
  <div 
    class="input-asset" 
    :class="{
      'input-asset--active': isLibraryVisible,
      'input-asset--disabled': disabled,
      'input-asset--multiple': multiple
    }"
  >
    <draggable v-if="multiple" v-model="libraryModel" @start="drag = true" @end="drag = false">
      <div v-for="asset in libraryModel" class="input-asset__asset" :key="asset.path">
        <img
          class="input-asset__thumb"
          :src="$store.state.assetsPath + asset.thumbPath"
        >
        <div class="input-asset__details">
          <div class="input-asset__description">{{ asset.description.length ? asset.description : 'No Description' }}</div>
          <div class="input-asset__path">{{ asset.path }}</div>
        </div>
        <div class="input-asset__remove">
          <button class="btn btn-sm btn-danger" @click="quickRemoveAsset(asset)"><fa :icon="['fas', 'minus-circle']" /></button>
        </div>
      </div>
    </draggable>    
    <div v-else-if="libraryModel && libraryModel.path.length">
      <div class="input-asset__asset">
        <img
          class="input-asset__thumb"
          :src="$store.state.assetsPath + libraryModel.thumbPath"
        >
        <div class="input-asset__details">
          <div class="input-asset__description">{{ libraryModel.description.length ? libraryModel.description : 'No Description' }}</div>
          <div class="input-asset__path">{{ libraryModel.path }}</div>
        </div>
        <div class="input-asset__remove">
          <button class="btn btn-sm btn-danger" @click="removeAsset"><fa :icon="['fas', 'minus-circle']" /></button>
        </div>
      </div>
    </div>
    <p v-if="requirements" class="small" v-html="requirements"></p>
    <div class="input-asset__actions input-asset__actions--vert">
      <button class="btn btn-secondary" v-if="!disabled" @click="openAssetLibrary">{{ (libraryModel && libraryModel.path) || (libraryModel && libraryModel.length) ? 'Change' : 'Choose' }} Asset{{ multiple ? 's' : '' }}</button>
      <!-- <button class="btn btn-danger mt-2" v-if="(libraryModel && libraryModel.path) || (libraryModel && libraryModel.length)" @click="removeAsset">{{ (libraryModel && libraryModel.path) || (libraryModel && libraryModel.length) ? 'Remove' : 'Choose' }} Asset{{ multiple ? 's' : '' }}</button> -->
    </div>
    <asset-library
      v-if="isLibraryVisible"
      v-model="libraryModel"
      :multiple="multiple"
      :defaultCategory="defaultCategory ? defaultCategory : ''"
      @close="closeAssetLibrary"
    ></asset-library>
  </div>
</template>
<script>
import _ from 'lodash'
import AssetLibrary from '@/components/NewAssetLibrary'
import Draggable from 'vuedraggable'
export default {
  components: { AssetLibrary, Draggable },

  props: ['disabled', 'value', 'required-dimensions', 'multiple', 'defaultCategory', 'requirements', 'returnid'],

  data () {
    return {
      isLibraryVisible: false,
      libraryModel: null,
    }
  },

  computed: {
    assets () {
      return this.$store.state.assetLibrary.assets
    },
  },

  mounted () {
    this.initLibraryModel ()
  },

  watch: {
    libraryModel () {
      if (this.libraryModel) {
        if (this.multiple) {
          console.log('this.libraryModel', this.libraryModel)
          const value = this.libraryModel.map(asset => {
            console.log('asset', asset)
            return asset.path
          })
          this.$emit('input', value)
        } else {
          if (this.returnid) {
            this.$emit('input', this.libraryModel._id)
          } else {
            this.$emit('input', this.libraryModel.path)
          }
        }
      }
    },

    assets () {
      this.initLibraryModel()
    },

    value () {
      if (this.libraryModel) {
        if (this.multiple) {
          const libraryModelPaths = JSON.stringify(this.libraryModel.map(asset => {
            return asset.path
          }))
          const valuePaths = JSON.stringify(this.value)
          if (libraryModelPaths !== valuePaths) {
            this.initLibraryModel ()
          }
        } else {
          if (this.returnid) {
            if (this.value !== this.libraryModel._id) {
              this.initLibraryModel ()
            }
          } else {
            if (this.value !== this.libraryModel.path) {
              this.initLibraryModel ()
            }
          }
          
        }
      } else {
        this.initLibraryModel()
      }
    }
  },

  methods: {
    closeAssetLibrary () {
      this.isLibraryVisible = false
    },

    openAssetLibrary () {
      if (!this.disabled)
        this.isLibraryVisible = true
    },

    initLibraryModel () {
      if (this.assets.length) {
        if (this.multiple) {
          let libraryModel = []
          this.value.forEach(path => {
            libraryModel.push(_.find(this.assets, asset => {
              return asset.path === path
            }))
          })
          this.libraryModel = libraryModel
        } else {
          if (this.returnid) {
            this.libraryModel = null
            if (this.value) {
              
              this.libraryModel = _.find(this.assets, asset => {
                return asset._id === this.value
              })
            } else {
              this.libraryModel = null
            }
            
          } else {
            this.libraryModel = _.find(this.assets, asset => {
              return asset.path === this.value
            })
          }
          
        }
      }
    },

    quickRemoveAsset (asset) {
      this.libraryModel = _.remove(this.libraryModel, libAsset => {
        return libAsset._id !== asset._id
      })
    },

    removeAsset () {
      if (this.multiple) {
        this.$emit('input', [])
      } else {
        if (this.returnid) {
          this.$emit('input', null)
        } else {
          this.$emit('input', '')
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .input-asset {
    border: 1px solid #d4d4d4;
    border-radius: 4px;
    max-width: 400px;
    padding: 7px;
    width: 100%;

    &--multiple {
      .input-asset__asset {
        cursor: grab;
      }
    }

    &__col {
      width: 50%;
    }

    &__asset {
      border: 1px solid #d4d4d4;
      border-radius: 4px;
      display: flex;
      width: 100%;
      margin-bottom: 7px;
    }

    &__thumb {
      background-color: #eee;

      overflow: hidden;
      height: 100px;
      width: 100px;
      object-fit: contain;
      margin: 0 0 0 auto;
      display: block;
      flex-shrink: 0;

      .input-asset--disabled & {
        cursor: default;
      }
    }

    &__details {
      width: 100%;
      padding: 7px;
      word-break: break-all;
    }
    
    &__path {
      opacity: 0.5;
      font-size: 0.8em;
    }

    &__actions {
      display: flex;
      justify-content: space-between;

      &--vert {
        flex-direction: column;
      }
    }

    &--active {
      border-color: #80bdff;
    }
  }
</style>